<template>
  <div class="inline">
    <a-button type="link" @click="getmissioninfobaogao">成绩分析</a-button>
    <a-modal :visible="visible" :width="1200" title="成绩分析" @ok="handleCancel" @cancel="handleCancel"
      :destroyOnClose="true" :footer="null">
      <div class="echarts-list">
        <div class="paper-analyse">
          <p class="title">{{ title }}</p>
          <p class="sub-title">{{ squadinfo.grade_name }}试卷分析</p>
          <div id="paper-analyse" style="height: 250px;"></div>
          <p class="pie-title">
            <span>知识模块占比</span>
            <span>知识难度占比</span>
          </p>
        </div>
        <div class="bar-chart">
          <div class="module-analyse">
            <div id="module-analyse" style="height: 400px;"></div>
            <p class="sub-title">知识模块分析</p>
          </div>
          <div class="difficulty-analyse">
            <div id="difficulty-analyse" style="height: 400px;"></div>
            <p class="sub-title">知识难度分析</p>
          </div>
        </div>
      </div>
      <record title="成绩分析" :chapter_name="title" :class_id="item.squad_id" />
    </a-modal>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  props: {
    item: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      visible: false,
      title: '',
      squadinfo: {},
      series: {
        type: 'bar',
        barGap: 0,
        emphasis: {
          focus: 'series'
        },
        label: {
          show: true,
          // position: 'insideBottom',
          // distance: 15,
          align: 'center',
          // verticalAlign: 'middle',
          // rotate: 90,
          formatter: '{c}',
          fontSize: 13
        }
      }
    }
  },
  created() {
  },
  mounted() {
    this.paperAnalyse()
  },
  methods: {
    handleCancel() {
      this.visible = false;
    },
    async getmissioninfobaogao() {
      this.visible = true;
      try {
        let { code, data: { squadinfo, squadnodelist, squadstarlist, title } } = await this.$axios.post('/api/BasicMission/getmissioninfobysquad', {
          data: {
            mission_id: this.item.mission_id,
            squad_id: this.item.squad_id,
          }
        });
        this.title = title;
        this.squadinfo = squadinfo;
        this.paperAnalyse(squadnodelist, squadstarlist)
        this.moduleAnalyse(squadnodelist)
        this.difficultyAnalyse(squadstarlist)
      } catch (error) {
        console.log(error);
      }
    },
    paperAnalyse(squadnodelist, squadstarlist) {
      const chartBox = echarts.init(document.getElementById('paper-analyse'));
      const option = {
        series: [
          {
            type: 'pie',
            radius: '90%',
            center: ['25%', '50%'],
            label: {
              // position: 'inner',
              formatter: '{b}:{c}'

            },
            data: squadnodelist.map(item => {
              return {
                name: item.nadename,
                value: Number(Number(item.score).toFixed(2))
              }
            })
          },
          {
            type: 'pie',
            radius: '90%',
            center: ['75%', '50%'],
            label: {
              // position: 'inner',
              formatter: '{b}:{c}'
            },
            data: squadstarlist.map(item => {
              return {
                name: item.star + ' 星',
                value: Number(Number(item.score).toFixed(2))
              }
            })
          }
        ]
      };
      chartBox.setOption(option);
      window.addEventListener("resize", function () {
        chartBox.resize();
      });
    },
    moduleAnalyse(source) {
      const chartBox = echarts.init(document.getElementById('module-analyse'));
      let arr = ['满分', '平均分', '最高分']
      const option = {
        tooltip: {},
        legend: {},
        toolbox: {
          show: true,
          orient: 'vertical',
          left: 'right',
          top: 'center',
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar', 'stack'] },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        xAxis: [
          {
            type: 'category',
            axisTick: { show: false },
            data: source.map(item => {
              return item.nadename
            })
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: ['score', 'avgscore', 'topscore'].map((item, key) => {
          return {
            ...this.series,
            name: arr[key],
            data: source.map(value => {
              return Number(Number(value[item]).toFixed(2))
            })
          }
        })
      };
      chartBox.setOption(option);
      window.addEventListener("resize", function () {
        chartBox.resize();
      });
    },
    difficultyAnalyse(source) {
      const chartBox = echarts.init(document.getElementById('difficulty-analyse'));
      let arr = ['满分', '平均分', '最高分']
      const option = {
        tooltip: {},
        legend: {},
        toolbox: {
          show: true,
          orient: 'vertical',
          left: 'right',
          top: 'center',
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar', 'stack'] },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        xAxis: [
          {
            type: 'category',
            axisTick: { show: false },
            data: source.map(item => {
              return item.star + ' 星'
            })
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: ['score', 'avgscore', 'topscore'].map((item, key) => {
          return {
            ...this.series,
            name: arr[key],
            data: source.map(value => {
              return Number(Number(value[item]).toFixed(2))
            })
          }
        })
      };
      chartBox.setOption(option);
      window.addEventListener("resize", function () {
        chartBox.resize();
      });
    }
  }
}
</script>

<style lang="less" scoped>
.inline {
  display: inline;
  margin-right: 1rem;
}

.echarts-list {
  .bar-chart {
    display: flex;
    margin-top: 5rem;

    >div {
      flex: 1;
    }
  }

  .title {
    font-size: 1.7rem;
    font-weight: bold;
    text-align: center;
  }

  .sub-title {
    font-size: 1.3rem;
    font-weight: bold;
    text-align: center;
  }

  .pie-title {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 1rem;

    span {
      font-size: 1.5rem;
      font-weight: bold;
    }
  }
}</style>